import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LayoutService } from 'src/app/layout/layout.service';
import { Language, LanguageCode, LanguageFileName } from '../Models/WidgetSettingsModels';
import { GuestService } from './guest.service';

@Injectable({
    providedIn: 'root'
})
export class LocalizeService {

    constructor(public translateService: TranslateService,
        public ls: LayoutService, private guestService: GuestService) { }

    public setLanguage(language: string, propertyType, literalsFolder?) {


        let translationPath = '';
        if (language) {
            let property = literalsFolder ? literalsFolder : window.location.href.split("/")[5];
            translationPath = 'customLiterals/' + property + '/' + language.toLowerCase();
            let customLiteralsPathAvailable = false;
            this.translateService.use(translationPath).subscribe(res => {
                customLiteralsPathAvailable = true
                this.setTranslatePath(translationPath, language, propertyType, language);
            }, err => {
                if (!customLiteralsPathAvailable) {
                   // language = LanguageFileName[(language)];
                    translationPath = this.getFallbackLangPath(language, propertyType);
                    this.setTranslatePath(translationPath, language, propertyType, language);
                }
            })
        }
        else{
            language = LanguageFileName[Number(LanguageFileName.english)];
            translationPath = this.getFallbackLangPath(language, propertyType);

            this.setTranslatePath(translationPath, language, propertyType, language);
        }

    }

    private setTranslatePath(path, language, propertyType, fallbackLang) {
        
        this.translateService.use(path).subscribe(res => {
            language = language?.toLowerCase()
            this.ls.language = Number(LanguageFileName[language]);
            sessionStorage.setItem('languageId', LanguageFileName[language]);
            sessionStorage.setItem('languageCode', LanguageCode[language]);
        }, err => {
            if(fallbackLang){
                this.setTranslatePath(this.getFallbackLangPath(fallbackLang,propertyType), language, propertyType, null);
            }else if(propertyType){
                this.setTranslatePath(this.getFallbackLangPath(LanguageFileName[Number(LanguageFileName.english)],propertyType), language, null, null);
            }
        });
    }

    private getFallbackLangPath(language: string, propertyType): string{
        this.ls.language = LanguageFileName[language] || LanguageFileName.english;
        return propertyType + '/' + language.toLowerCase();
    }
}